import { render, staticRenderFns } from "./UnidadeMedidaForm.vue?vue&type=template&id=03483a93&lang=html"
import script from "./UnidadeMedidaForm.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports